<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/utils/shadcn/lib/utils';

defineOptions({
    compatConfig: {
        MODE: 3,
    },
});

const props = defineProps<{
    class?: HTMLAttributes['class']
}>();
</script>

<template>
    <div
        data-slot="field-content"
        :class="cn(
            'group/field-content flex flex-1 flex-col gap-1.5 leading-snug',
            props.class,
        )"
    >
        <slot></slot>
    </div>
</template>
